














































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  reportIncidentFields,
  ReportIncidentErrorObject,
} from '@bookings/config/reportBookingEventIncidentConfig';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import { BookingEventIncidentReport } from '@bookings/interfaces/booking-event';

@Component({
  name: 'ReportIncidentModal',
  components: {
    'bpc-input-group': InputGroup,
    'bpc-input': Input,
    'bpc-select': Select,
    'bpc-switch': Switch,
    'bpc-textarea': Textarea,
  },
})
export default class ReportIncidentModal extends Vue {
  @Prop({ type: String, default: 'report-incident-modal' }) readonly modalId!: string;
  @Prop({ type: Boolean, default: false }) readonly showModal!: boolean;
  @Prop(Object) readonly bookingEventIncidentReport: BookingEventIncidentReport;

  public isLoading: boolean = true;
  public isProcessing: boolean = false;
  public formModel: BookingEventIncidentReport = this.createEmptyFormModel();

  public errorsObject: ReportIncidentErrorObject = {};

  get fieldsConfig() {
    return reportIncidentFields;
  }

  get modalTitle(): string {
    return this.$t('bookings.modals.report-incident.title').toString();
  }

  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  createEmptyFormModel(): BookingEventIncidentReport {
    return {
      id: null,
      real_number_of_participants: null,
      real_number_of_participants_description: null,
      incident_to_report: false,
      incident_type: null,
      incident_description: null,
    };
  }

  onChangeErrorObject(field: keyof ReportIncidentErrorObject) {
    delete this.errorsObject[field];
  }

  closeModal() {
    this.$emit('close-modal');
    this.resetForm();
    this.$bvModal.hide(this.modalId);
  }

  openModal() {
    this.$bvModal.show(this.modalId);
    this.isLoading = false;
  }

  resetForm() {
    this.formModel = {
      id: null,
      real_number_of_participants: null,
      real_number_of_participants_description: null,
      incident_to_report: false,
      incident_type: null,
      incident_description: null,
    };
    this.errorsObject = {};
  }

  async onConfirmReportIncident() {
    this.isProcessing = true;
    const url = `${this.$bpcApiRouteHelper.getEntityPath('booking-event')}/${
      this.formModel.id
    }/patch-incident-report`;
    const body = {
      ...this.formModel,
    };

    try {
      const res = await this.$bpcApi.patch(url, body).toPromise();

      if (res.data) {
        this.$emit('incident-report-updated');
        this.isProcessing = false;
        this.closeModal();
      } else {
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error' });
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        this.manageSaveErrors(error?.response?.data?.errors);
      }
    }
    this.isProcessing = false;
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      const aux = {
        error: errors[key][0],
        state: false,
      };
      this.$set(this.errorsObject, key, aux);
    });
  }

  sanitizeNumber() {
    const value = this.formModel.real_number_of_participants.toString();
    const sanitizedNumber = parseInt(value.replace(/[^\d]/g, ''));
    this.formModel.real_number_of_participants = sanitizedNumber;
  }

  @Watch('showModal')
  onShowModalChange(val: boolean) {
    if (val) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }

  @Watch('bookingEventIncidentReport', { immediate: true, deep: true })
  onValueChange(newValue: BookingEventIncidentReport) {
    this.formModel = { ...newValue };
  }
}
